// ======================================================================
// File: src/modules/ppe/pages/procurement/purchaseInvoice/services/purchaseInvoiceService.js
// Module: PPE → Procurement → Purchase Invoice
//
// Purpose:
// - Axios based service layer for Purchase Invoice module
// - Mirrors backend routes exactly
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/purchase-invoice";

const purchaseInvoiceService = {

  // ----------------------------------------------------------
  // CREATE PURCHASE INVOICE
  // ----------------------------------------------------------
  createPurchaseInvoice: async (payload) => {
    const response = await axiosClient.post(
      BASE_URL,
      payload
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // UPDATE PURCHASE INVOICE
  // ----------------------------------------------------------
  updatePurchaseInvoice: async (
    purchaseInvoiceId,
    payload
  ) => {
    const response = await axiosClient.put(
      `${BASE_URL}/${purchaseInvoiceId}`,
      payload
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // GET PURCHASE INVOICE LIST
  // ----------------------------------------------------------
  getPurchaseInvoiceList: async (
    params = {}
  ) => {
    const response = await axiosClient.get(
      BASE_URL,
      {
        params,
      }
    );

    return response.data;
  },

  // ----------------------------------------------------------
  // GET PURCHASE INVOICE DETAIL
  // ----------------------------------------------------------
  getPurchaseInvoiceById: async (
    purchaseInvoiceId
  ) => {
    const response = await axiosClient.get(
      `${BASE_URL}/${purchaseInvoiceId}`
    );

    return response.data;
  },

  // ----------------------------------------------------------
  // SUBMIT PURCHASE INVOICE
  // ----------------------------------------------------------
  submitPurchaseInvoice: async (
    purchaseInvoiceId
  ) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${purchaseInvoiceId}/submit`
    );

    return response.data;
  },

  // ----------------------------------------------------------
  // APPROVE PURCHASE INVOICE
  // ----------------------------------------------------------
  approvePurchaseInvoice: async (
    purchaseInvoiceId
  ) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${purchaseInvoiceId}/approve`
    );

    return response.data;
  },

  
  getAvailableCharges: async (
  purchaseInvoiceId
) => {

  const response =
    await axiosClient.get(
      `${BASE_URL}/${purchaseInvoiceId}/available-charges`
    );

  return response.data;
},
  
  
  // ----------------------------------------------------------
  // POST PURCHASE INVOICE
  // ----------------------------------------------------------
  postPurchaseInvoice: async (
    purchaseInvoiceId
  ) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${purchaseInvoiceId}/post`
    );

    return response.data;
  },

  getAvailableGRNs: async (vendorId) => {
  const response = await axiosClient.get(
    `${BASE_URL}/available-grns/${vendorId}`
  );

  return response.data;
},

getGRNLines: async (grnIds) => {
  const response = await axiosClient.get(
    `${BASE_URL}/grn-lines`,
    {
      params: {
        grn_ids: grnIds.join(",")
      }
    }
  );

  return response.data;
},

// ----------------------------------------------------------
// UPLOAD ATTACHMENT
// ----------------------------------------------------------
uploadAttachment: async (
  purchaseInvoiceId,
  file
) => {

  const formData = new FormData();

  formData.append(
    "file",
    file
  );

  const response =
    await axiosClient.post(
      `${BASE_URL}/${purchaseInvoiceId}/attachments`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data"
        }
      }
    );

  return response.data;
},

// ----------------------------------------------------------
// GET ATTACHMENTS
// ----------------------------------------------------------
getAttachments: async (
  purchaseInvoiceId
) => {

  const response =
    await axiosClient.get(
      `${BASE_URL}/${purchaseInvoiceId}/attachments`
    );

  return response.data;
},

// ----------------------------------------------------------
// DELETE ATTACHMENT
// ----------------------------------------------------------
deleteAttachment: async (
  attachmentId
) => {

  const response =
    await axiosClient.delete(
      `${BASE_URL}/attachments/${attachmentId}`
    );

  return response.data;
},

// ----------------------------------------------------------
// DOWNLOAD ATTACHMENT
// ----------------------------------------------------------
getAttachmentDownloadUrl: (
  attachmentId
) => {

  return (
    `${BASE_URL}/attachments/`
    + attachmentId
    + "/download"
  );
},

downloadAttachment: async (
  attachmentId
) => {

  const response =
    await axiosClient.get(
      `${BASE_URL}/attachments/${attachmentId}/download`,
      {
        responseType: "blob"
      }
    );

  return response.data;
},

};


export default purchaseInvoiceService;